module.exports = __webpack_public_path__ + "static/media/what-are-coding-bootcamps.920ef053.png";